var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  { attrs: { label: "小程序:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.form.appid,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appid", $$v)
                          },
                          expression: "form.appid",
                        },
                      },
                      _vm._l(_vm.wxapplist, function (item, index) {
                        return _c("el-option", {
                          attrs: { label: item, value: index },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "时间筛选:" } }, [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "开始",
                          "value-format": "timestamp",
                          "picker-options": _vm.beginOptions,
                        },
                        model: {
                          value: _vm.form.begin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "begin", $$v)
                          },
                          expression: "form.begin",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "结束",
                          "value-format": "timestamp",
                          "picker-options": _vm.endOptions,
                        },
                        model: {
                          value: _vm.form.end,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "end", $$v)
                          },
                          expression: "form.end",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                      },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [
                        _vm._v("重置"),
                        _c("i", {
                          staticClass: "el-icon-refresh el-icon--right",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "p-5" }, [
        _c(
          "div",
          { staticClass: "bg-white" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "order_table",
                staticClass: "ptd-5",
                attrs: {
                  id: "order_table",
                  data: _vm.list,
                  "max-height": _vm.tableMaxH,
                  "element-loading-text": "Loading",
                  stripe: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "投诉单号", width: "140" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.complaint_id) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "关联订单信息", width: "350" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.complaint_order_info &&
                          scope.row.complaint_order_info.length > 0
                            ? _vm._l(
                                scope.row.complaint_order_info,
                                function (item) {
                                  return _c("div", [
                                    _c("span", { staticClass: "mr-10" }, [
                                      _vm._v(
                                        "交易单号：" +
                                          _vm._s(item.transaction_id)
                                      ),
                                    ]),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "订单金额：￥" + _vm._s(item.amount)
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "ml-10 text-blue",
                                          attrs: {
                                            href:
                                              "/order/order?transaction_id=" +
                                              item.transaction_id,
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v("查看订单")]
                                      ),
                                    ]),
                                  ])
                                }
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "投诉内容" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "text-cut_two" }, [
                            _vm._v(_vm._s(scope.row.complaint_detail)),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "投诉时间", width: "110" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.RFCToDate(scope.row.complaint_time)) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "投诉次数", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(scope.row.user_complaint_times) + "次"
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "状态", width: "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.statu[scope.row.complaint_state])
                            ),
                          ]),
                          _vm._v(" "),
                          scope.row.complaint_full_refunded
                            ? _c("div", { staticClass: "mt-5 text-primary" }, [
                                _vm._v("已全额退款"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          scope.row.incoming_user_response &&
                          scope.row.complaint_state != "PROCESSED"
                            ? _c("div", { staticClass: "mt-5 text-danger" }, [
                                _vm._v("待回复用户"),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "退款备注", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "text-danger" }, [
                            _vm._v(_vm._s(scope.row.withdraw_reason || "--")),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "操作", width: "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              staticClass: "ml-0",
                              attrs: {
                                type: "primary",
                                size: "mini",
                                round: "",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push({
                                    path:
                                      "/userManage/PCDetail?id=" +
                                      scope.row.complaint_id +
                                      "&appid=" +
                                      _vm.form.appid,
                                  })
                                },
                              },
                            },
                            [_vm._v("详情")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex justify-center" },
              [
                _c("pagination", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.listQuery.page_num > 0,
                      expression: "listQuery.page_num > 0",
                    },
                  ],
                  attrs: {
                    page: _vm.listQuery.start,
                    limit: _vm.listQuery.limit,
                    "page-count": _vm.listQuery.page_num,
                  },
                  on: {
                    "update:page": function ($event) {
                      return _vm.$set(_vm.listQuery, "start", $event)
                    },
                    "update:limit": function ($event) {
                      return _vm.$set(_vm.listQuery, "limit", $event)
                    },
                    pagination: _vm.getList,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }